exports.default = {
  'new_conversation_tooltip': 'New Chat',
  'history_tooltip': 'History',
  'conversation': 'Chats',
  'loading': 'Loading',
  'expand': 'Expand',
  'collapse': 'Collapse',
  'start_new_conversation': 'New Chat',
  'history': 'History',
  'pin_conversation': 'Pin conversation',
  'edit_conversation_title': 'Edit Chat Name',
  'remove_conversation_confirm': 'Delete Confirmation',
  'please_enter_conversation_name': 'Enter a new name for this chat',
  'delete_conversation_confirm': 'This action cannot be undone. Are you sure you want to delete?',
  'delete': 'Delete',
  'cancel': 'Cancel',
  'operation_failed': 'Operation failed: {message}',
  'empty_conversation_id': 'Conversation ID is empty, please refresh the page and try again!',
  'empty_title': 'Please enter a conversation title!',
  'title_too_long': 'Title cannot exceed 150 characters',
  'copy_success': 'Copy successful',
  'copy_failed': 'Copy failed, please try again later!',
  'no_agent_conversation': 'You haven\'t had any conversations with agents yet',
  'agent_deleted': 'Agent has been deleted, cannot start a new conversation',
  'no_more': 'No more',
  'continue_chat': 'Continue chatting with Pai',
  'ai_generated_content': 'Content generated by AI model, please verify carefully',
  'new_conversation': 'New conversation',
  'add_conversation_title': 'Please enter conversation title',
  'confirm': 'Confirm',
  'your_agents': 'Your agents',
  'edit_conversation_failed': 'Operation failed: {message}',
  'add_top_success': 'Added successfully!',
  'export_pdf': 'Export PDF document',
  'agent_center': 'Agent Center',
  'remove_agent': 'Remove agent',
  'add_agent': 'Add agent',
  'today': 'Today',
  'search_agent_placeholder': 'Search agent name or description',
  'recent': 'Recent',
  'points': 'Points',
  'points_consumption': 'Points consumed per message:',
  'remaining_points': 'Your current remaining points:',
  'points_info_load_error': 'Points information loading failed',
  'upgrade': 'Upgrade',
  'search_chat': 'Search agents or conversations...',
  'agent_type': 'Agent',
  'conversation_message_type': 'Conversation Message',
  'network_connection_unstable': 'Your network connection is unstable. Please refresh the page and try again.'
}
